// Query
import { useQuery } from '@apollo/client'
import {
  GetEmailValidatorQuery,
  GetEmailValidatorQueryVariables,
  GetUserQueryResult,
} from 'lib/graphql/graphqlTypes'
import { EMAIL_VALIDATOR } from 'graphql/queries/user.query'
import * as Yup from 'yup'
import { useState } from 'react'

const useEmailValidator = (
  userData: GetUserQueryResult['data'],
  validatorEmailMessage: string,
) => {
  const [validatorEmail, setValidatorEmail] = useState<string>('')

  const { data: emailValidatorData } = useQuery<
    GetEmailValidatorQuery,
    GetEmailValidatorQueryVariables
  >(EMAIL_VALIDATOR, {
    variables: {
      input: { email: validatorEmail },
    },
    fetchPolicy: 'network-only',
    skip:
      !validatorEmail ||
      validatorEmail === userData?.user?.contactInfo.primaryEmailAddress,
  })

  const emailValidator = emailValidatorData?.emailValidator

  /**
   * add state based validator to primaryEmail
   */
  const primaryEmailAddress = Yup.string().test(
    'Email Validator',
    validatorEmailMessage,
    function () {
      if (userData?.user?.id) {
        return true
      }
      return !!emailValidatorData?.emailValidator.isValid
    },
  )

  /**
   * create second schema
   */
  const moreValidationSchema = Yup.object().shape({
    primaryEmailAddress,
  })

  return {
    moreValidationSchema,
    emailValidator,
    setValidatorEmail,
    emailValidatorData,
  }
}
export default useEmailValidator
